export default __webpack_public_path__ + "static/media/factura5.ad051f1c.pdf";